import React, { useState } from "react";
import { Input, Row, Typography, Col, Card, Select, Form } from "antd";

const { Text } = Typography;

export const CurrencyForm = (props) => {
  const { loanProductDetails, useForm, currencyData } = props;

  return (
    <Form layout="vertical" form={useForm}>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Currency</Text>} name={"currencyCode"}>
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Decimal Places</Text>}
            name={"digitsAfterDecimal"}
          >
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Currency In Multiples Of</Text>}
            name={"inMultiplesOf"}
          >
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Installment In Multiples Of</Text>}
            name={"installmentAmountInMultiplesOf"}
          >
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
